import { useParams, useSearchParams } from 'react-router-dom';

import { FeatureCreateResume as FeatureCreateResumeView } from './feature-create-resume';
import { CreateResumeProvider } from './create-resume.context';
import {
  CreateResumeMode,
  CreateResumeStep,
  isCreateResumeStep,
} from './create-resume.store';

const CREATE_RESUME_STEP_QUERY_PARAM = 'step';

export { CreateResumeMode } from './create-resume.store';
export { ResumeHeader } from './resume-header';

export type FeatureCreateResumeProps = {
  initialStep?: CreateResumeStep;
  mode?: CreateResumeMode;
  resumeId?: string;
  syncStepWithUrl?: boolean;
};

export const FeatureCreateResume = ({
  initialStep,
  mode = CreateResumeMode.CREATE,
  resumeId,
  syncStepWithUrl = true,
}: FeatureCreateResumeProps) => {
  const params = useParams();
  const resolvedResumeId = resumeId ?? params.id;

  if (syncStepWithUrl) {
    return (
      <UrlSyncedFeatureCreateResume
        initialStep={initialStep}
        mode={mode}
        resumeId={resolvedResumeId}
      />
    );
  }

  return (
    <CreateResumeProvider
      initialStep={initialStep}
      mode={mode}
      resumeId={resolvedResumeId}
    >
      <FeatureCreateResumeView syncStepWithUrl={false} />
    </CreateResumeProvider>
  );
};

const UrlSyncedFeatureCreateResume = ({
  initialStep,
  mode,
  resumeId,
}: {
  initialStep?: CreateResumeStep;
  mode: CreateResumeMode;
  resumeId?: string;
}) => {
  const [searchParams] = useSearchParams();
  const queryStep = searchParams.get(CREATE_RESUME_STEP_QUERY_PARAM);
  const resolvedInitialStep =
    isCreateResumeStep(queryStep) ? queryStep : initialStep;

  return (
    <CreateResumeProvider
      initialStep={resolvedInitialStep}
      mode={mode}
      resumeId={resumeId}
    >
      <FeatureCreateResumeView syncStepWithUrl />
    </CreateResumeProvider>
  );
};
